/* Team Cats slide cart b1 (design B, one-tap checklist). Markup and offer rules: sections/tc-cart-drawer.liquid.
   window.TCCart.open({source}) returns true when it took over (the landers call it after Add; false = go to /cart).
   Kill switch: ?tc_cart_off=1 (sticks; ?tc_cart_on=1 undoes), localStorage tc_cart_off=1, TCCart.disable(), or the
   section's "Slide cart on" setting. Holdout: tc_arm cookie/localStorage, 'offers' or 'holdout', written to the cart as
   _tc_arm. Events: dataLayer + document 'tc:cart' + Shopify.analytics.publish('tc_cart_<name>'). */
(function () {
  if (window.TCCart) return;
  var el = document.getElementById('TcCart');
  if (!el) return;
  var V = el.dataset.version || 'b1', SECTION = el.dataset.section || 'tc-cart-drawer';
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
  };
  var qs = new URLSearchParams(location.search);
  if (qs.get('tc_cart_off') === '1') store.set('tc_cart_off', '1');
  if (qs.get('tc_cart_on') === '1') store.set('tc_cart_off', null);
  var killed = el.dataset.enabled !== 'true' || store.get('tc_cart_off') === '1';

  function cookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  var arm = qs.get('tc_arm') || store.get('tc_arm') || cookie('tc_arm');
  if (arm !== 'offers' && arm !== 'holdout') arm = Math.random() * 100 < Number(el.dataset.holdout || 0) ? 'holdout' : 'offers';
  if (arm === 'holdout' && Number(el.dataset.holdout || 0) === 0 && qs.get('tc_arm') !== 'holdout') arm = 'offers'; // holdout switched off
  store.set('tc_arm', arm);
  document.cookie = 'tc_arm=' + arm + '; path=/; max-age=' + 60 * 60 * 24 * 30 + '; samesite=lax';

  function emit(name, data) {
    var p = { event: 'tc_cart_' + name, tc_cart_v: V, tc_arm: arm };
    for (var k in data || {}) p[k] = data[k];
    try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('tc:cart', { detail: p })); } catch (e) {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('tc_cart_' + name, p); } catch (e) {}
  }
  // Merchanting Watch: explicit element actions for the drawer (consented visits only; Watch ignores the rest).
  // Watch keeps at most 60 elements per page view and landers already fill them, so the drawer's own summary lives on
  // the root element (declared first, always has a slot): open = drawer opened, change = an add-on added from the
  // drawer, complete = Secure checkout clicked (click = any tap inside, counted by Watch itself). The per-part
  // components (tc.cart.offer.*, tc.cart.nudge.*, tc.cart.checkout ...) record wherever the page has room left.
  var wSeen = {};
  function wroot(action) {
    try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('element_action', { kind: 'cart', action: action, component_id: 'tc.cart.drawer' }); } catch (e) {}
  }
  function wt(el, action) {
    var id = el && el.getAttribute && el.getAttribute('data-watch-component'), kind = el && el.getAttribute('data-tcc-wk');
    if (!id || !kind) return;
    try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('element_action', { kind: kind, action: action, component_id: id }); } catch (e) {}
  }
  function onCartPage() { return /^\/cart\/?$/.test(location.pathname); }
  function enabled() { return !killed; }

  var busy = false, lastFocus = null, opened = false;
  function inner() { return el.querySelector('#TcCartInner'); }
  function msg(t) { var m = el.querySelector('[data-tcc-msg]'); if (m) m.textContent = t || ''; }

  function post(url, body) {
    body.sections = SECTION + ',cart-icon-bubble';
    body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart error'); return j; }); });
  }
  function pickEl(html, sel) { return html ? new DOMParser().parseFromString(html, 'text/html').querySelector(sel) : null; }
  function pick(html, sel) { var d = pickEl(html, sel); return d ? d.innerHTML : null; }
  function paint(j) {
    var s = (j && j.sections) || {};
    var next = pickEl(s[SECTION], '#TcCartInner');
    if (next) {
      var cur = inner(), scroller = el.querySelector('[data-tcc-scroll]'), top = scroller ? scroller.scrollTop : 0;
      // the count, total, arm and skip list live on the inner element itself: carry them over with the content
      Array.prototype.forEach.call(next.attributes, function (a) { if (a.name.indexOf('data-') === 0) cur.setAttribute(a.name, a.value); });
      cur.innerHTML = next.innerHTML;
      var sc = el.querySelector('[data-tcc-scroll]'); if (sc) sc.scrollTop = top;
    }
    var bubble = document.getElementById('cart-icon-bubble'), b = pick(s['cart-icon-bubble'], '.shopify-section');
    if (bubble && b !== null) bubble.innerHTML = b;
    seen();
    orphans();
    leashPrice();
  }
  // protection with no product (e.g. insurance AfterSell added at checkout, then the product removed here): the section
  // shows the empty cart and lists those line keys in data-orphan; take them out so they can't reach checkout alone
  var orphanTries = 0;
  function orphans() {
    var i = inner(), keys = i && i.getAttribute('data-orphan');
    if (!keys) { orphanTries = 0; return; }
    if (orphanTries > 1) return; // two clears in a row that left protection behind: stop, the page-load guard retries
    orphanTries++;
    var u = {};
    keys.split(',').forEach(function (k) { if (k) u[k] = 0; });
    post('/cart/update.js', { updates: u }).then(function (j) { emit('protect_orphan_clear', {}); paint(j); }).catch(function () {});
  }
  // one request on open: keeps the arm and version on the cart (they land on the order) and returns the fresh drawer
  function refresh() {
    return post('/cart/update.js', { attributes: { _tc_arm: arm, _tc_cart_v: V } }).then(paint);
  }

  function show() {
    el.hidden = false;
    document.documentElement.classList.add('tcc-lock');
    var go = function () { if (opened) el.classList.add('is-open'); };
    requestAnimationFrame(function () { requestAnimationFrame(go); });
    setTimeout(go, 120); // still slides in if the page draws no frames (e.g. a background tab)
    var x = el.querySelector('.tcc-x'); if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close() {
    if (!opened) return;
    opened = false;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('tcc-lock');
    setTimeout(function () { if (!opened) el.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    emit('close', {});
  }
  function open(opts) {
    if (!enabled()) return false;
    opts = opts || {};
    lastFocus = document.activeElement;
    opened = true;
    el.classList.add('is-loading');
    show();
    refresh().catch(function () {}).then(function () {
      el.classList.remove('is-loading');
      var i = inner();
      wroot('open');
      emit('open', { source: opts.source || 'other', lander: opts.lander || null, items: Number(i && i.dataset.count || 0), value: Number(i && i.dataset.total || 0) / 100, rows: Number(i && i.dataset.rows || 0) });
    });
    return true;
  }

  // impressions: once per offer and rank per session, when at least half the row is in view inside the drawer
  var io = null;
  function seen() {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    var root = el.querySelector('[data-tcc-scroll]');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || !opened) return;
        var r = e.target, wid = r.getAttribute('data-watch-component');
        if (wid && !wSeen[wid]) { wSeen[wid] = 1; wt(r, 'open'); }
        if (!r.dataset.tccOffer) { io.unobserve(r); return; } // the nudge only reports to Watch
        var id = 'tcc_seen_' + r.dataset.tccOffer + ':' + r.dataset.rank;
        try { if (sessionStorage.getItem(id)) return; sessionStorage.setItem(id, '1'); } catch (x) {}
        emit('impression', info(r));
        io.unobserve(r);
      });
    }, { root: root, threshold: 0.5 });
    el.querySelectorAll('[data-tcc-offer]:not([data-key]), .tcc-nudge').forEach(function (r) { io.observe(r); });
  }
  function info(r) {
    return { offer_id: r.dataset.tccOffer, lane: r.dataset.lane, rank: Number(r.dataset.rank || 0), variant: Number(r.dataset.variant || 0), price: Number(r.dataset.price || 0) / 100 };
  }

  function run(p, done) {
    if (busy) return;
    busy = true; el.classList.add('is-busy'); msg('');
    p.then(function (j) { paint(j); if (j && j.tccMsg) msg(j.tccMsg); if (done) done(); })
      .catch(function (e) { msg(e && e.message && e.message !== 'cart error' ? e.message : 'That didn’t work. Please try again.'); emit('error', { message: String(e && e.message || e).slice(0, 120) }); })
      .then(function () { busy = false; el.classList.remove('is-busy'); });
  }
  // Bungee leash in the drawer at the product page's price (audit 2026-11-01). The cat harness page sells the leash inside
  // the kit for +$30 (Harness + Bungee Leash $79.99 against $49.99), but this row added the $39.99 leash on its own. With a
  // cat harness line in the cart the row now shows the kit's difference and swaps that line to the same color's leash kit;
  // once the harness line's kit already holds the leash, the row is hidden.
  var HK = 'new-cat-harness', hk = null;
  fetch('/products/' + HK + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { hk = p; leashPrice(); }).catch(function () {});
  function isLeash(r) { return /leash/i.test(r.dataset.tccOffer || ''); }
  function leashTarget() {
    var i = inner();
    if (!hk || !hk.variants || !i) return null;
    var lines = i.querySelectorAll('[data-key][data-variant]');
    for (var n = 0; n < lines.length; n++) {
      var v = Number(lines[n].dataset.variant), cur = null, to = null, k;
      for (k = 0; k < hk.variants.length; k++) if (Number(hk.variants[k].id) === v) { cur = hk.variants[k]; break; }
      if (!cur) continue;
      var kit = String(cur.option2 || '');
      var want = kit === 'Harness' ? 'Harness + Bungee Leash' : kit === 'Harness + 9 Patch Bundle' ? 'Harness + Bungee Leash + 9 Patch Bundle' : '';
      if (!want) continue;
      for (k = 0; k < hk.variants.length; k++) {
        var x = hk.variants[k];
        if (x.option1 === cur.option1 && x.option2 === want && x.available !== false) { to = x; break; }
      }
      if (to) return { line: lines[n], from: cur, to: to };
    }
    return null;
  }
  function kitHasLeash() {
    var i = inner();
    if (!hk || !hk.variants || !i) return false;
    return Array.prototype.some.call(i.querySelectorAll('[data-key][data-variant]'), function (l) {
      return hk.variants.some(function (x) { return Number(x.id) === Number(l.dataset.variant) && /Bungee Leash/.test(String(x.option2 || '')); });
    });
  }
  function leashPrice() {
    var i = inner(), t = leashTarget(), has = !t && kitHasLeash();
    if (!i || (!t && !has)) return;
    i.querySelectorAll('[data-tcc-offer]').forEach(function (r) {
      if (!isLeash(r) || r.dataset.key) return;
      if (has) { r.hidden = true; return; }
      var m = r.querySelector('[data-tcc-money]');
      if (m) m.textContent = '+$' + ((Number(t.to.price) - Number(t.from.price)) / 100).toFixed(2);
    });
  }
  function leashSwap(r, props) {
    if (!isLeash(r)) return null;
    var t = leashTarget();
    if (!t) return null;
    var q = Number(t.line.dataset.qty || 1), p = lineProps(t.line), k;
    for (k in props) p[k] = props[k];
    return post('/cart/change.js', { id: t.line.dataset.key, quantity: Math.max(0, q - 1) })
      .then(function () { return post('/cart/add.js', { items: [{ id: Number(t.to.id), quantity: 1, properties: p }] }); });
  }
  function toggle(r) {
    var d = info(r);
    wt(r, r.dataset.key ? 'change' : 'click');
    if (!r.dataset.key) wroot('change');
    if (r.dataset.key) {
      run(post('/cart/change.js', { id: r.dataset.key, quantity: 0 }), function () { emit(d.lane === 'protect' ? 'protect_remove' : 'offer_remove', d); });
      return;
    }
    // a row whose variant the shopper must pick (no colour matches the hero): nothing is pre-picked
    if (r.hasAttribute('data-pick') && !r.dataset.variant) {
      var name = r.querySelector('.tcc-row-copy b'), first = r.querySelector('[data-tcc-chip]');
      r.classList.add('is-missing');
      msg('Pick a ' + (r.dataset.pick || 'option') + (name ? ' for the ' + name.textContent.trim().toLowerCase() : '') + ', then tap it again.');
      if (first) try { first.focus({ preventScroll: false }); } catch (e) {}
      return;
    }
    var props = { _tc_upsell: 'drawer:' + d.offer_id + ':' + d.rank };
    if (r.dataset.textProp) {
      var input = r.querySelector('[data-tcc-text]'), val = input ? input.value.trim() : '';
      if (!val) { r.classList.add('is-missing'); msg('Type the name to print, then tap the patches again.'); if (input) input.focus(); return; }
      props[r.dataset.textProp] = val;
    }
    var sw = leashSwap(r, props);
    if (sw) { run(sw, function () { emit('offer_add', d); }); return; }
    run(post('/cart/add.js', { items: [{ id: d.variant, quantity: 1, properties: props }] }), function () { emit(d.lane === 'protect' ? 'protect_add' : 'offer_add', d); });
  }

  // Kaching quantity deal: the line takes the deal's property with the bid for its new quantity; the cart must then
  // charge what the button said (pct off each unit, rounded down), else the line goes back to how it was
  // Liquid prints line properties as [[name, value], ...]; the cart API wants an object
  function lineProps(line) {
    var raw = null, p = {};
    try { raw = JSON.parse(line.dataset.props || '{}'); } catch (e) { raw = null; }
    if (Array.isArray(raw)) raw.forEach(function (kv) { if (Array.isArray(kv) && kv.length > 1) p[kv[0]] = kv[1]; });
    else if (raw && typeof raw === 'object') p = raw;
    return p;
  }
  function dealProps(line, bid) {
    var p = lineProps(line);
    p.__kaching_bundles = JSON.stringify({ deal: line.dataset.deal, pp: Number(line.dataset.pp), main: true, bid: bid });
    return p;
  }
  function qtyDeal(line, q, bid, expect) {
    var variant = Number(line.dataset.variant), oldQ = Number(line.dataset.qty), oldProps = lineProps(line);
    var d = { product: Number(line.dataset.pp), variant: variant, qty: q, expect: expect / 100 };
    run(post('/cart/change.js', { id: line.dataset.key, quantity: q, properties: dealProps(line, bid) }).then(function (j) {
      var it = null;
      (j.items || []).forEach(function (x) { if (x.variant_id === variant && x.quantity === q && String((x.properties || {}).__kaching_bundles || '').indexOf(bid) > -1) it = x; });
      if (it && it.final_line_price <= expect + q) { emit('qty_deal_add', d); return j; }
      emit('qty_deal_fail', d);
      if (!it) return j;
      return post('/cart/change.js', { id: it.key, quantity: oldQ, properties: oldProps }).then(function (j2) { j2.tccMsg = 'That deal didn’t apply, so your cart is unchanged.'; return j2; });
    }));
  }

  el.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-tcc-close]')) { e.preventDefault(); close(); return; }
    var chip = t.closest('[data-tcc-chip]');
    if (chip) {
      var row = chip.closest('[data-tcc-offer]');
      row.dataset.variant = chip.dataset.tccChip; row.dataset.price = chip.dataset.price;
      row.querySelectorAll('[data-tcc-chip]').forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
      var m = row.querySelector('[data-tcc-money]'); if (m) m.textContent = chip.dataset.money;
      if (row.classList.contains('is-missing')) { row.classList.remove('is-missing'); msg(''); }
      return;
    }
    var tg = t.closest('[data-tcc-toggle]');
    if (tg) { e.preventDefault(); toggle(tg.closest('[data-tcc-offer]') || tg); return; }
    var dn = t.closest('[data-tcc-deal]');
    if (dn) { wt(dn, 'click'); wroot('change'); qtyDeal(dn.closest('[data-key]'), Number(dn.dataset.tccDeal), dn.dataset.bid, Number(dn.dataset.expect)); return; }
    var q = t.closest('[data-tcc-qty]');
    if (q) {
      var line = q.closest('[data-key]'), nq = Number(q.dataset.tccQty), body = { id: line.dataset.key, quantity: nq };
      if (nq === 0) { try { window.MerchantingWatch && window.MerchantingWatch.track && window.MerchantingWatch.track('element_action', { kind: 'cart_remove', action: 'click', component_id: 'tc.cart.line.remove' }); } catch (e) {} }
      else wt(line, 'change');
      // a Kaching deal line keeps the bid that matches its new quantity (1-3), so the deal follows the stepper
      var bids = (line.dataset.bids || '').split(',');
      if (line.dataset.deal && nq >= 1 && nq <= 3 && bids[nq - 1]) body.properties = dealProps(line, bids[nq - 1]);
      run(post('/cart/change.js', body), function () { emit(nq === 0 ? 'line_remove' : 'line_qty', { qty: nq }); });
      return;
    }
    var sk = t.closest('[data-tcc-skip]');
    if (sk) {
      wt(sk, 'click');
      var cur = (inner() && inner().dataset.skip) || '';
      run(post('/cart/update.js', { attributes: { _tc_skip: (cur ? cur + ',' : '') + sk.dataset.tccSkip } }), function () { emit('offer_skip', { hero: sk.dataset.tccSkip }); });
      return;
    }
    if (t.closest('[data-tcc-link]')) { wt(t.closest('[data-tcc-offer]'), 'click'); emit('offer_link', info(t.closest('[data-tcc-offer]'))); return; }
    if (t.closest('[data-tcc-checkout]')) { wt(t.closest('[data-tcc-checkout]'), 'click'); wroot('complete'); var i = inner(); emit('checkout_click', { items: Number(i.dataset.count || 0), value: Number(i.dataset.total || 0) / 100 }); }
  });
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Enter' && e.target.matches('[data-tcc-text]')) { e.preventDefault(); toggle(e.target.closest('[data-tcc-offer]')); }
  });
  el.addEventListener('input', function (e) { var r = e.target.closest && e.target.closest('.is-missing'); if (r) { r.classList.remove('is-missing'); msg(''); } });

  // the header cart icon opens the drawer (not on /cart itself)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a || !enabled() || onCartPage() || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    open({ source: 'icon' });
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted && opened) refresh().catch(function () {}); });

  window.TCCart = {
    version: V, arm: arm,
    enabled: enabled,
    open: open, close: close, refresh: function () { return refresh(); },
    disable: function () { store.set('tc_cart_off', '1'); killed = true; document.documentElement.classList.remove('tcc-on'); close(); emit('kill_switch', { on: false }); },
    enable: function () { store.set('tc_cart_off', null); killed = el.dataset.enabled !== 'true'; if (!killed) document.documentElement.classList.add('tcc-on'); emit('kill_switch', { on: !killed }); }
  };
  if (killed && store.get('tc_cart_off') === '1') emit('kill_switch', { on: false, via: 'stored' });
})();
